import { Link, NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { initials } from '../utils/theme';
import { BRAND } from '../config/brand';

export default function AppHeader() {
  const { user, memberships, canManageOrg, isPlatformAdmin, signOut } = useAuth();
  const { pathname } = useLocation();
  // Companies this person runs (owner/admin); the link opens the first, the page has a switcher
  const company = memberships.find((m) => m.organizations?.kind === 'company' && canManageOrg(m.org_id));
  const navClass = ({ isActive }) =>
    `px-3 py-2 rounded-lg text-sm whitespace-nowrap ${isActive ? 'bg-blue-soft text-blue font-semibold' : 'text-ink-muted font-medium hover:text-ink'}`;
  return (
    <header className="bg-white border-b border-line">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 min-h-16 py-3 flex flex-wrap items-center gap-x-6 gap-y-2">
        <Link to="/" aria-label={`${BRAND.name} home`}><img src={BRAND.logo.lockup} alt={BRAND.name} className="h-[32px] w-auto" /></Link>
        <nav className="flex gap-1 order-last w-full overflow-x-auto sm:order-none sm:w-auto sm:flex-1" aria-label="Main">
          <NavLink to="/" end className={navClass}>My cards</NavLink>
          <NavLink to="/leads" className={navClass}>Leads</NavLink>
          {company && (
            <NavLink to={`/company/${company.org_id}`} className={() => navClass({ isActive: pathname.startsWith('/company/') })}>Company</NavLink>
          )}
        </nav>
        <div className="flex items-center gap-3 ml-auto">
          {isPlatformAdmin && (
            <Link to="/admin" className="h-9 px-3 rounded-lg border border-line-strong text-sm font-semibold text-ink flex items-center hover:bg-surface">
              Admin console
            </Link>
          )}
          <Link to="/account" title="Your account: password and Google sign-in" className="flex items-center gap-3 rounded-full hover:opacity-80">
            <span className="hidden md:inline text-sm text-ink-muted truncate max-w-[200px]">{user?.email}</span>
            <span className="w-9 h-9 rounded-full bg-navy text-white font-display font-bold text-sm flex items-center justify-center" aria-hidden="true">
              {initials(user?.email?.split('@')[0]?.replace(/[._-]+/g, ' '))}
            </span>
            <span className="sr-only">Your account</span>
          </Link>
          <button onClick={() => signOut()} className="h-9 px-3 rounded-lg text-sm font-medium text-ink-muted hover:text-ink hover:bg-surface">
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
